export const EDIT_TL_SUBSCRIPTION_OPTIONS_MODAL_NAME =
  'EDIT_TL_SUBSCRIPTION_OPTIONS_MODAL_NAME';
